import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/discounts/voucher/:voucherId/';

type MutationFnType = typeof mutationFn;

interface DTO {
    voucherId: string;
}
const mutationFn = ({ voucherId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { voucherId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteVoucher };
